import * as React from "react";
import PercentageLabel from "./PercentageLabel";
import * as utils from "../utils";
import {Label} from "react-bootstrap";

export default class ProjectRow extends React.Component{

    goToProjectPage(){
        this.props.history.push("/projects/" + this.props.project.id)
    }

    render(){

        const {project, hasTasks} = this.props;

        return <tr className="hoverable" onClick={this.goToProjectPage.bind(this)}>
            <td>
                {project.name}
            </td>
            {hasTasks ? ([
                <td className="budget" key="budget">
                    {utils.formatHours(project.budgetMinutesTotal)}
                </td>,
                <td key="minutes">
                    {utils.formatHours(project.minutesTotal)}
                </td>,
                <td style={{verticalAlign: "top"}} key="percentage">
                    <span />
                    {!!project.minutesTotal && !!project.budgetMinutesTotal && (
                        <PercentageLabel a = {project.minutesTotal} b={project.budgetMinutesTotal} minutes={true} label="Project" showPercentage />
                    )}
                </td>
            ]):(
                <td colSpan={3}>
                    <Label bsStyle="danger">This project has no tasks yet</Label>
                </td>
            )}
        </tr>
    }
}

// export default connect()(ProjectRow)


// WEBPACK FOOTER //
// ./src/components/ProjectRow.js